export const TOOL_OPTIONS = [
    { key: 'create_task', labelKey: 'Create new task' },
    { key: 'create_note', labelKey: 'Create new note' },
    { key: 'update_task', labelKey: 'Update task' },
    { key: 'update_note', labelKey: 'Update note' },
    // One key for get/read/create/update_artifact; the server fans it out (Artifacts/artifactToolSchemas.js).
    { key: 'artifacts', labelKey: 'Create and edit artifacts' },
    { key: 'update_contact', labelKey: 'Update contact' },
    { key: 'add_chat_comment', labelKey: 'Add chat comment' },
    { key: 'correct_email_classification', labelKey: 'Correct email classification' },
    { key: 'update_user_memory', labelKey: 'Update user memory' },
    { key: 'update_heartbeat_settings', labelKey: 'Update heartbeat settings' },
    { key: 'update_project_description', labelKey: 'Update project description' },
    { key: 'update_user_description', labelKey: 'Update user description' },
    { key: 'update_assistant_settings', labelKey: 'Update assistant settings' },
    { key: 'compact_thread_context', labelKey: 'Compact thread context' },
    { key: 'get_tasks', labelKey: 'Get tasks' },
    { key: 'get_updates', labelKey: 'Get updates' },
    { key: 'get_goals', labelKey: 'Get goals' },
    { key: 'get_project_okrs', labelKey: 'Get project OKRs' },
    { key: 'get_project_happiness', labelKey: 'Get project happiness' },
    { key: 'get_chats', labelKey: 'Get chats' },
    { key: 'get_contacts', labelKey: 'Get contacts' },
    { key: 'get_focus_task', labelKey: 'Get focus task' },
    { key: 'get_user_projects', labelKey: 'Get user projects' },
    { key: 'search', labelKey: 'Search content' },
    { key: 'search_gmail', labelKey: 'Search emails' },
    { key: 'list_recent_chat_media', labelKey: 'List recent chat media' },
    { key: 'get_chat_attachment', labelKey: 'Get chat attachment' },
    { key: 'get_gmail_attachment', labelKey: 'Get email attachment' },
    { key: 'create_gmail_reply_draft', labelKey: 'Create email reply draft' },
    { key: 'create_gmail_draft', labelKey: 'Create email draft' },
    { key: 'update_gmail_draft', labelKey: 'Update email draft' },
    { key: 'update_gmail_email', labelKey: 'Update email' },
    { key: 'find_calendar_availability', labelKey: 'Find free Calendar times' },
    { key: 'search_calendar_events', labelKey: 'Search Calendar events' },
    { key: 'create_calendar_event', labelKey: 'Create Calendar event' },
    { key: 'update_calendar_event', labelKey: 'Update Calendar event' },
    { key: 'delete_calendar_event', labelKey: 'Delete Calendar event' },
    { key: 'get_notes', labelKey: 'Get notes' },
    { key: 'web_search', labelKey: 'Search the internet' },
    { key: 'fetch_url', labelKey: 'Read a web page' },
    { key: 'browser_automation', labelKey: 'Browse a website' },
    { key: 'find_profile_photo', labelKey: 'Find a profile photo' },
    { key: 'get_route_info', labelKey: 'Check distance and route between locations' },
    { key: 'get_local_recommendations', labelKey: 'Get local recommendations nearby' },
    { key: 'get_weather', labelKey: 'Check the weather' },
    { key: 'execute_task_in_vm', labelKey: 'Run task in a VM' },
    { key: 'external_tools', labelKey: 'Use external app tools' },
    { key: 'mcp_servers', labelKey: 'Use connected MCP servers' },
    { key: 'talk_to_assistant', labelKey: 'Talk to assistants' },
]

// The one Tools Access key that fans out to the six `browser_*` tool names on the server. Exported
// so the tools modal can attach the allowlist editor to exactly this row without matching a string
// literal in two places.
export const BROWSER_TOOL_KEY = 'browser_automation'

export const TOOL_LABEL_BY_KEY = TOOL_OPTIONS.reduce((acc, option) => {
    acc[option.key] = option.labelKey
    return acc
}, {})

// Powerful / billable tools that must be explicitly enabled per assistant.
// `mcp_servers` reaches out to external MCP servers (per-assistant configured) and
// is metered, so it is opt-in rather than on by default.
// `browser_automation` drives a real browser on the owner's behalf: it is the only tool that can
// interact with a third-party site rather than read it, it needs an explicit site allowlist before
// it does anything at all, and it runs on infrastructure that costs money per session. Whoever
// switches it on should be making that decision deliberately.
export const OPT_IN_ONLY_TOOLS = new Set(['mcp_servers', 'browser_automation'])

export const DEFAULT_ALLOWED_TOOLS = TOOL_OPTIONS.map(option => option.key).filter(key => !OPT_IN_ONLY_TOOLS.has(key))

// Map renamed tool keys so Firestore data with old names resolves correctly
const TOOL_KEY_RENAMES = { get_note: 'get_notes' }

const VALID_KEYS = new Set(TOOL_OPTIONS.map(o => o.key))

export function normalizeAllowedTools(allowedTools) {
    if (!Array.isArray(allowedTools)) return []
    const seen = new Set()
    const result = []
    for (const key of allowedTools) {
        const mapped = TOOL_KEY_RENAMES[key] || key
        if (!seen.has(mapped)) {
            seen.add(mapped)
            result.push(mapped)
        }
    }
    return result
}
